var map = {
	"./backspace.svg": 59267,
	"./circle_back.svg": 72958,
	"./circle_close.svg": 27724,
	"./copy.svg": 91186,
	"./eye_close.svg": 49406,
	"./eye_open.svg": 2352,
	"./facebook_icon.svg": 86269,
	"./google_icon.svg": 97330,
	"./master_password.svg": 64802,
	"./menu.svg": 6023,
	"./security.svg": 99400,
	"./security_icon.svg": 74401,
	"./transaction_icon.svg": 17070,
	"./twitter_icon.svg": 60930,
	"./wallet.svg": 42834,
	"./wallet_icon.svg": 58415
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 70634;